import { SUBSCRIPTION_BUTTON } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  content: [],
  subscriptionButtonStatus: undefined,
  subscriptionButtonError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_BUTTON.FETCH:
      return {
        ...state,
        subscriptionButtonStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case SUBSCRIPTION_BUTTON.SUCCESS:
      return {
        ...state,
        ...action.payload,
        subscriptionButtonStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case SUBSCRIPTION_BUTTON.FAILED:
      return {
        ...state,
        subscriptionButtonError: action.payload,
        subscriptionButtonStatus: CONSTANTS.API_STATUS.FAILED,
      };
    default:
      return state;
  }
};
